import React, { useState, useEffect } from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import AboutTheClub from "components/hero/TwoColumnWithInput.js";
import BeginnersCourse, { BeginnersCourse2023 } from "components/hero/BeginnersCourse";
import MainFeature from "components/features/TwoColWithButton.js";
import FAQ, {CovidFAQ} from "components/custom/FAQs";
import GetStarted from "components/cta/GetStarted";
import TabGrid from "components/cards/TabCardGrid.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import styled from "styled-components";

//todo: clean this up, give the bar a background
import {NavLink} from "./components/headers/light.js";
import ThreeColWithSideImageWithPrimaryBackground from "components/features/ThreeColWithSideImageWithPrimaryBackground.js";

import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";

const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
const LeftColumn = tw.div`relative lg:w-6/12 lg:pr-12 flex-shrink-0 text-center lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex flex-col justify-center`;
const Content = tw.div`px-4 flex flex-1 flex-col justify-center items-center`;

const Heading = styled.h1`
  ${tw`text-3xl text-center sm:text-4xl lg:text-5xl xl:text-6xl font-black text-black leading-snug -mt-24 sm:mt-0`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SubHeading = styled.h2`
  ${tw`text-2xl text-center sm:text-3xl lg:text-4xl xl:text-5xl font-black text-black leading-snug -mt-24 sm:mt-0`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const Image = tw.img`ml-auto`;

const Subheading = tw.span`tracking-wider text-sm font-medium`;
const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const Description = tw.span`inline-block mt-8`;
const imageCss = tw`rounded-4xl`;

const PrimaryButton = styled(PrimaryButtonBase)(props => [
  tw`mt-8 md:mt-8 text-sm inline-block mx-auto md:mx-0`,
  tw`rounded-full`
]);

const Link = tw.a`border-b-2 border-transparent hocus:text-green-600 hocus:border-red-300 pb-1 transition duration-300 mt-2 mx-4`;

const Content2025 = () => {
  return (
          <Image src="./img/bc.png" />
  )
};

const Content2024 = () => {
  return (
    <>
    <TwoColumn>
        <LeftColumn>
          <Image src="./img/xmas_ideas.jpg" />
        </LeftColumn>
        <RightColumn>
        <Content>
            <Heading>
              Merry Christ<u>Mask</u>!
            </Heading>
            <br />
            Our last session of the year will be on Dec 19.<br />Decorate your mask and join us for fun, games, snacks and festive cheer.
          </Content>
        </RightColumn>
      </TwoColumn>
    <TwoColumn>
        <LeftColumn>
        <Content>
            <Heading>
              At the Hub!
            </Heading>
            <br />
            On November 14 and again on December 5 we will be at <b>the Hub - Penparcau Community Centre</b><br />
            <a href="/#/TheHub"><u>Click here for more details.</u></a>
          </Content>
        </LeftColumn>
        <RightColumn>
        <Image src="https://penparcau.cymru/wp-content/uploads/2020/02/Hwb-1-1024x685.jpg" />
        <a href="https://penparcau.cymru/">https://penparcau.cymru</a>
        </RightColumn>
      </TwoColumn>
      <TwoColumn>
        <LeftColumn>
          <Content>
            <Heading>
              Back to Penweddig!
            </Heading>
            <br />
            The floor is repaired and we are back starting September 4th.
          </Content>
        </LeftColumn>
          <RightColumn>
          <Content>
            <img src="./img/3628827_d2dbf018_original.jpg" alt="Penweddig School © Copyright Ian Capper"/>
            <span style={{fontSize: '6px'}}>© Copyright Ian Capper and licensed for reuse under <a href="http://creativecommons.org/licenses/by-sa/2.0/">this Creative Commons Licence.</a></span>
          </Content>
        </RightColumn>
      </TwoColumn>
      <TwoColumn>
        <LeftColumn>
        <Content><img src="./img/SBCE.png"/></Content>
        </LeftColumn>
          <RightColumn>
          <Content><img src="./img/SBCW.png"/></Content>
        </RightColumn>
      </TwoColumn>
      {/* <TwoColumn>
        <LeftColumn>
        <Content>
            <Heading>
              We're Moving!
            </Heading>
            <br />
            From July 25 to August 29 we will be at <b>the Hub - Penparcau Community Centre</b><br />
            <a href="/#/SummerLocation"><u>Click here for more details.</u></a>
          </Content>
        </LeftColumn>
        <RightColumn>
        <Image src="https://penparcau.cymru/wp-content/uploads/2020/02/Hwb-1-1024x685.jpg" />
        <a href="https://penparcau.cymru/">https://penparcau.cymru</a>
        </RightColumn>
      </TwoColumn>
      <TwoColumn>
        <LeftColumn>
        <Image src={'./img/easter.avif'} />
        <a href="https://www.freepik.com/free-photo/happy-bunny-with-many-easter-eggs-grass-festive-background-decorative-design_38121621.htm#query=easter%20holiday&position=9&from_view=keyword&track=ais&uuid=d4f03eac-be1b-43aa-824b-8ac4907caf13">Image by svstudioart</a> on Freepik
        </LeftColumn>
        <RightColumn>
        <Content>
            <Heading>
              Easter Break
            </Heading>
            <br />
            <SubHeading>
            No fencing until April 11. Enjoy the break!<br />
            </SubHeading>
          </Content>
        </RightColumn>
      </TwoColumn>

      <TwoColumn>
        <LeftColumn>
        <Content>
            <Heading>
              New Beginners Course
            </Heading>
            <br />
            <SubHeading>
            Email <Link href="mailto:aberfencing@gmail.com?subject=beginner%20course">aberfencing@gmail.com</Link><br/>
             &nbsp; if interested.<br />
            </SubHeading>
          </Content>
        </LeftColumn>
        <RightColumn>
          <a href="./img/2024 Beginners.jpg"><Image src={'./img/2024 Beginners.jpg'} /></a>
          
        </RightColumn>
      </TwoColumn>

      <TwoColumn>
        <LeftColumn>
        <a title="Happy New Year 2024 by Marco Verch CC BY 2.0 &lt;https://creativecommons.org/licenses/by/2.0&gt;">
            <a href="./img/2024.jpg"><Image src={'./img/2024.jpg'} /></a>
          </a>
        </LeftColumn>
        <RightColumn>
        <Content>
            <Heading>
              Reminder
            </Heading>
            <br />
            <SubHeading>
            no fencing on January 4
            </SubHeading>
          </Content>
        </RightColumn>
      </TwoColumn> */}
    </>
  )
};

const Content2023 = () => {
  return (
    <>
      <TwoColumn>
        <LeftColumn>
        <Content>
            <Heading>
              New Beginners Course
            </Heading>
            <br />
            <SubHeading>
            Email <Link href="mailto:aberfencing@gmail.com?subject=beginner%20course">aberfencing@gmail.com</Link><br/>
             &nbsp; if interested.<br />
            </SubHeading>
          </Content>
        </LeftColumn>
        <RightColumn>
          <a href="./img/bc2.jpeg"><Image src={'./img/bc2.jpeg'} /></a>
          
        </RightColumn>
      </TwoColumn>

      <TwoColumn>
        <LeftColumn>
          <Image src={'./img/wvfa.jpg'} />
        </LeftColumn>
        <RightColumn>
          <Content>
            <Heading>
              WVFA Championships
            </Heading>
            <br />
            <SubHeading>
              Full results are<Link href='https://www.fencingtimelive.com/tournaments/eventSchedule/239710E2B62944A8A16EF495EFB47633#today'>here</Link>.<br/>Well done to all of you!
            </SubHeading>
          </Content>
        </RightColumn>
      </TwoColumn>


      <BeginnersCourse2023 />

      <TwoColumn>
        <LeftColumn>
            <img alt="Tesco/M&S store in Aberystwyth" src="https://t0.geograph.org.uk/stamp.php?id=5410279&title=on&gravity=SouthEast&hash=7b5885ac"/>
        </LeftColumn>
        <RightColumn>
          <Content>
            <Heading>
              Thank you Tesco!
            </Heading>
            <br />
            <SubHeading>
            For hosting our First Aid training on May 14.
            </SubHeading>
          </Content>
        </RightColumn>
      </TwoColumn>

      <TwoColumn>
        <LeftColumn>
          <Content>
            <Heading>
              Session Cancelled
            </Heading>
            <br />
            <SubHeading>
            There is no fencing on May 4.<br/>See you on the 11th!
            </SubHeading>
          </Content>
        </LeftColumn>
        <RightColumn>
          <a title="Petful from New York City, USA, CC BY 2.0 &lt;https://creativecommons.org/licenses/by/2.0&gt;, via Wikimedia Commons" href="https://commons.wikimedia.org/wiki/File:Darth_Vader_Dog_(8126557438).jpg">
            <img width="350" style={{webkitTransform: "scaleX(-1)", transform: "scaleX(-1)"}} alt="Darth Vader Dog (8126557438)" src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Darth_Vader_Dog_%288126557438%29.jpg/256px-Darth_Vader_Dog_%288126557438%29.jpg"/>
          </a>
        </RightColumn>
      </TwoColumn>

      <TwoColumn>
        <LeftColumn>
          <Image src={'./img/ss.jpg'} />
        </LeftColumn>
        <RightColumn>
          <Content>
            <Heading>
              The 2023 Osgood Invitational
            </Heading>
            <br />
            <SubHeading>
              <u><a href='https://www.facebook.com/groups/2222799862/posts/10162139045179863/'>Photos</a></u> and <u><a href='https://www.facebook.com/groups/2222799862/posts/10162139740444863/'>videos</a></u> available from the A.U.F.C.'s <u><a href='https://www.facebook.com/groups/2222799862/'>Facebook page</a></u>.
            </SubHeading>
          </Content>
        </RightColumn>
      </TwoColumn>

      <TwoColumn>
        <LeftColumn>
          <Image src={'./img/happy-easter.png'} />
        </LeftColumn>
        <RightColumn>
          <Content>
            <Heading>
              Enjoy Your Easter Break
            </Heading>
            <br />
            <SubHeading>
              There is no fencing on April 6 or 13.<br/>See you on the 20th!
            </SubHeading>
          </Content>
        </RightColumn>
      </TwoColumn>

      <TwoColumn>
        <LeftColumn>
        <Content>
            <Heading>
              Session Cancelled
            </Heading>
            <br />
            <SubHeading>
              There is no fencing on February 9.<br/>See you on the 16th!
            </SubHeading>
          </Content>
        </LeftColumn>
        <RightColumn>
          <Image src={'./img/saddog.jpg'} />
        </RightColumn>
      </TwoColumn>

      <TwoColumn>
        <LeftColumn>
          <Image src={'./img/agm.png'} />
        </LeftColumn>
        <RightColumn>
          <Content>
            <Heading>
              Annual General Meeting
            </Heading>
            <br />
            <SubHeading>
              This will be held on January 12 at 18:45 in the school hall prior to the start of the session.
            </SubHeading>
            <a href='https://drive.google.com/file/d/13HlpkWcE-Ty-iWZu3LsbXtfoAoKjXRWZ/view?usp=share_link'>Click here for our constitution</a>
          </Content>
        </RightColumn>
      </TwoColumn>

      <TwoColumn>
        <LeftColumn>
          <Content>
            <Heading>
              Reminder
            </Heading>
            <br />
            <SubHeading>
              There is no session on Thursday, 5 January 2023.
            </SubHeading>
          </Content>
        </LeftColumn>
        <RightColumn>
          <Image src={'./img/hny.jpg'} />
        </RightColumn>
      </TwoColumn>


    </>
  )
};

const Content2022 = () => {
  return (
    <>
      <TwoColumn>
        <LeftColumn>
          <Content>
            <Image src={'./img/moving-in-the-night-tom-browne.jpg'} />
          </Content>
        </LeftColumn>
        <RightColumn>
          <Content>
            <Heading>
              WE'RE MOVING
            </Heading>
            <br />
            <SubHeading>
              Our new home is Penweddig School.
            </SubHeading>
            <PrimaryButton as="a" href='#Location'>
              Click for Directions
            </PrimaryButton>
          </Content>
        </RightColumn>
      </TwoColumn>
      <TwoColumn>
        <LeftColumn>
          <Content>
            <Heading>Summer Break</Heading>
            <SubHeading>
              See you in September!
            </SubHeading>
          </Content>
        </LeftColumn>
        <RightColumn>
          <Image src={'./img/Hello_Summer.png'} />
        </RightColumn>
      </TwoColumn>
      <TwoColumn>
        <LeftColumn>
          <Image src={'./img/queens_platinum_jubilee_english_0.png'} />
        </LeftColumn>
        <RightColumn>
          <Content>
            <Heading>
              SESSION CANCELLED
            </Heading>
            <br />
            <SubHeading>
              There is no session on Thursday, 2 June 2022.
            </SubHeading>
          </Content>
        </RightColumn>
      </TwoColumn>
    </>
  );
};

const Content2021 = () => {
  const [imageToShow, setImageToShow] = useState(1);
  const image = "./img/xmas" + imageToShow + ".jpg";
  useEffect(() => {
    setTimeout(() => {
      setImageToShow((imageToShow+1)%7);
    }, 5000);
  }, [imageToShow])

  return (
    <>
      <Hero
        heading={<>See you in <HighlightedText>2022</HighlightedText></>}
        description={<span>Our last session of the year was Christmask on Dec 16.<br/> See you again in the New Year!</span>}
        imageSrc={image}
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText=""
        primaryButtonUrl=""
        watchVideoButtonText="Get inspired!"
      />
      <br/>
      <BeginnersCourse />
      <CovidFAQ></CovidFAQ>
      <MainFeature
        subheading={<Subheading>Last Updated 04/08/2021</Subheading>}
        heading={
          <>
            Covid-19
            <wbr /> <HighlightedText>Return to Fencing</HighlightedText>
          </>
        }
        description={
          <Description>
            Welsh Fencing has published a roadmap for the next two months.<br/>
            Indoor fencing may resume on <b>17th of May</b> (subject to Welsh Government guidelines which could change).<br/>
            <br/>
            Check back for club news as the date approaches.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={true}
        primaryButtonText="Find Out More From Welsh Fencing"
        primaryButtonUrl="https://fencing.cymru/index.php/component/content/article/9-latest-news/953-return-to-fencing-roadmap?Itemid=101"
        imageSrc={
          "https://cdn.pixabay.com/photo/2020/04/01/21/05/mask-4992753_960_720.png"
        }
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
    </>
  );
};

const Content2020 = () => {
  return (
    <>
      <GetStarted 
       text = "Be visited by the spirit of Christmask past..."
       primaryLinkText = "Click here for our Christmask Calendar"
       primaryLinkUrl = "#/ChristmaskCalendar"
       pushDownFooter = {true}
       />
      <MainFeature
        subheading={<Subheading>Committe Meeting - 27/08/2020</Subheading>}
        heading={
          <>
            <HighlightedText>Prepare</HighlightedText><br></br>
            <wbr /> Restart, Rebuild
          </>
        }
        description={
          <Description>
            Our committee has been working to prepare for the day we can start fencing again.  Find out what's being done in the latest Committee Meeting Minutes.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Read More"
        primaryButtonUrl="https://drive.google.com/file/d/17zbC5Y4aR_w8NhPyuv_BG4LqU01C2R-R/view?usp=sharing"
        imageSrc={
          "https://www.britishfencing.com/wp-content/uploads/2020/06/ReturntoFencingFramework-486x269.jpg"
        }
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
    </>
  );
};

export const Home2024 = () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Content2024 />
      <Footer />
    </AnimationRevealPage>
  );
};

export const Home2023 = () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Content2023 />
      <Footer />
    </AnimationRevealPage>
  );
};

export const Home2022 = () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Content2022 />
      <Footer />
    </AnimationRevealPage>
  );
};

export const Home2021 = () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Content2021 />
      <Footer />
    </AnimationRevealPage>
  );
};

export const Home2020 = () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Content2020 />
      <Footer />
    </AnimationRevealPage>
  );
};


export default () => {
  const [show2024, setShow2024] = useState(false);
  const [show2023, setShow2023] = useState(false);
  const [show2022, setShow2022] = useState(false);
  const [show2021, setShow2021] = useState(false);
  const [show2020, setShow2020] = useState(false);

const load2024 =
  <ThreeColWithSideImageWithPrimaryBackground
    cards={[]}
    heading={<NavLink onClick={()=>setShow2024(true)}>Load more</NavLink>}
    description=''/>;

const load2023 =
  <ThreeColWithSideImageWithPrimaryBackground
    cards={[]}
    heading={<NavLink onClick={()=>setShow2023(true)}>Load more</NavLink>}
    description=''/>;

const load2022 =
  <ThreeColWithSideImageWithPrimaryBackground
    cards={[]}
    heading={<NavLink onClick={()=>setShow2022(true)}>Load more</NavLink>}
    description=''/>;

const load2021 =
  <ThreeColWithSideImageWithPrimaryBackground
    cards={[]}
    heading={<NavLink onClick={()=>setShow2021(true)}>Load more</NavLink>}
    description=''/>;

const load2020 =
  <ThreeColWithSideImageWithPrimaryBackground
    cards={[]}
    heading={<NavLink onClick={()=>setShow2020(true)}>Load more</NavLink>}
    description=''/>;

  return (
    <AnimationRevealPage>
      <Header />
      <Content2025 />
      {show2024
        ? <>
          <Content2024 />
          {show2023
            ? <>
              <Content2023 />
              {show2022
              ? <>
                <Content2022 />
                {show2021
                  ? <>
                    <Content2021 />
                    {show2020
                      ? <>
                      <Content2020 />
                      </> : load2020}
                  </> : load2021}
              </> : load2022}
            </> : load2023}
        </> : <></>//load2024
        }
      <AboutTheClub />
      <FAQ></FAQ>

{//TODO: use the TabGrid for a calendar of events
//TODO: use feature below to hi
//TODO: use something with people for coaches / executive

}
{/*
      <Features
        heading={
          <>
            Amazing <HighlightedText>Coaches.</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: shopIconImageSrc,
            title: "Oliver Massey",
            description: "Winner todo todo todo.",
            url: "https://google.com"
          },
          {
            imageSrc: chefIconImageSrc,
            title: "Alun Davies",
            description: "Member of todo todo todo",
          },
        ]}

        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      />
      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.* /}
      <TabGrid
        heading={
          <>
            Upcoming <HighlightedText>events.</HighlightedText>
          </>
        }
      />
*/}
      <Footer />
    </AnimationRevealPage>
  );
}

/* AboutFencing
To appreciate the history of fencing one must consider the impact of the sword on civilization. In prehistoric times man fashioned crude implements such as clubs and stone axes for both offensive and defensive purposes. The development of civilization is mirrored by the increased sophistication of human weaponry. Since the advent of metal weapons in the Bronze Age swords of some description have been fashioned. These have taken a variety of forms from simple copper daggers, through curving scimitars, to the enormous two handed swords of the middle ages. Similarly the usage of these weapons has varied according to circumstance. For example the Roman short-sword complemented the relatively lightly armored, highly mobile troops of the Empire, on the other hand the heavy armour of the Middle Ages required equally heavy weaponry to have any effect. The introduction of gun powder to warfare had a profound impact on the development of the sword. The heavy armour and weapons of the Middle Ages were rendered impractical and the sword evolved into a lighter more manageable weapon.

To master these lighter weapons guilds of masters developed throughout Europe and the art of fencing, in form recognizable to the sport of today was born. These schools developed various techniques and tactics, such as the stance, lunge and parries used today. Further, the growth of dueling in the sixteenth and seventeenth centuries provided the traditions of courtesy and customs also found in the modern sport.

Rivalry between various guilds led to the development of international fencing tournaments, this combined with the outlawing of dueling to the death, led to the gradual development of fencing as a sport with its own rules. Indeed fencing was included in the Olympic Games in Athens, 1896. There are three different weapons used in modern fencing, each with differing origins tactics and rules. These are outlined below.

 	


The foil (in England; firetta in Italy; fleuret in France) was developed as a training weapon for dueling in the mid-seventeenth century. The foil is a light sword, the weight of which must not exceed 500g and be less than 110cm in length. The blade is rectangular or square and tapers towards the point. The guard is relatively small and should pass through a 12cm gauge. Hits are scored with the point and must exert 500g of pressure. The curve of the blade shouldn't be greater than 2cm. The Foil target is the upper body (not including the arms or mask bib) down to the groin. This reflects the origin of the weapon i.e. as a practice for dueling, whereby an attack to the torso represents the greatest potential to cause a 'fatal' hit.

 	


Developed from the rapier, this was the everyday sword by the 16th Century, also used for dueling It is the heaviest of the three weapons (up to 770g) with a large shell/guard to protect the forearm (<13.5cm in diameter) and a tapered blade which is substantially wider at the guard than the point. Hits are scored using the point, and the target is unrestricted, so includes all of the fencer’s body and equipment.

 	


The sabre is a lighter reproduction of the cavalry sword. Its origins date from the eastern curving scimitar used my mounted Hungarian troops and the popular naval cutlass. The sabre differs from the other two weapons in that hits can be scored with the edge of the blade as well as the point. Sabre's must weigh no more than 500g and measure<105cm. The guard is curved to protect the hand and forearm. Sabre target area includes everything above the waist, i.e. the target that would be presented to an opponent by a mounted cavalryman.
*/